<template>
  <div class="player-invite">
    <div>
      <!-- Invitation modal when an invitation is received -->
      <div v-if="invitation">
        <p class="text-center">{{ invitation.inviterName }} has invited you to play!</p>
        <div class="flex flex-wrap gap-3 mt-4">
          <button
              @click="acceptInvite"
              class="btn btn-success grow"
          >
            Accept
          </button>
          <button
              @click="declineInvite"
              class="btn btn-error grow"
          >
            Decline
          </button>
        </div>
      </div>
      <div v-else>
        <h3 class="text-center">Players</h3>
        <div class="flex flex-wrap gap-2">
          <div class="flex items-center gap-2 w-full py-3.5 border-b border-[#A7A7A7]/20" v-for="user in filteredUsers" :key="user.id">
            <div class="flex justify-between flex-wrap gap-5 items-center w-full">
              <div class="flex gap-2 items-center">
                <div class="bg-success rounded-full size-3"></div>
                {{ user.name }}

                <span class="text-xs" v-if="userStatuses[user.id]" :class="{
                  'text-yellow-500': userStatuses[user.id] === 'Pending',
                }">({{ userStatuses[user.id] }})</span>
              </div>
              <button
                  @click="sendInvite(user.id, user.name)"
                  :disabled="userStatuses[user.id] === 'Pending'"
                  :class="{
                  'btn-secondary pointer-events-none opacity-20': userStatuses[user.id] === 'Pending',
                  }"
                  class="btn text-xs"
              >
                Invite
              </button>
            </div>
          </div>
          <div class="flex items-center gap-2 w-full py-3.5 border-b border-[#A7A7A7]/20">
            <div class="flex justify-between flex-wrap gap-5 items-center w-full">
              <div class="flex gap-2 items-center">
                <div class="bg-success rounded-full size-3"></div>
                Offline Bot
              </div>
              <button
                  @click="$emit('inviteBot', true)"
                  class="btn text-xs"
              >
                Invite
              </button>
            </div>
          </div>
          <button @click="copyUrl" class="btn btn-success w-full mt-4">
            Copy URL to invite
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlayerLobby",
  props: {
    socket: Object,
    activeUsers: Array,
    currentUserId: String,
    currentUsername: String,
  },
  data() {
    return {
      invitation: null, // Store the invitation if received
      userStatuses: {}, // Store invite statuses for each user
    };
  },
  computed: {
    // Exclude the current user from the active users
    filteredUsers() {
      return this.activeUsers.filter((user) => user.id !== this.currentUserId);
    },
  },
  mounted() {
    // Listen for incoming invitations
    this.socket.on("invitation", (data) => {
      console.log("Received invitation:", data);
      this.invitation = data;
    });

    // Listen for declined invites
    this.socket.on("invitationDeclined", (data) => {
      this.$showToast(`Invitation declined 😓`, false);

      // Reset the status for the invitee
      if (data.data.inviterId) {
        delete this.userStatuses[data.data.inviteeId];
      }
    });
  },
  methods: {
    sendInvite(userId, userName) {
      if (userId) {
        // Set status to "Pending" for the invitee
        this.userStatuses[userId] = "Pending";

        // Emit the invite event with inviterId and inviteeId
        this.socket.emit("invite", {
          inviterId: this.currentUserId,
          inviteeId: userId,
        });

        this.$showToast(`Invite sent to ${userName} 🤩`);
      }
    },

    inviteBot() {
      this.$showToast(`Create a game mode 🤩`);
    },

    // Accept invitation logic
    acceptInvite() {
      console.log(`You accepted the invitation from ${this.invitation.inviterName}.`);

      this.socket.emit("acceptInvite", {
        inviterId: this.invitation.inviterId,
        inviteeId: this.currentUserId,
      });

      // Clear the invitation after accepting
      this.invitation = null;
    },

    // Decline invitation logic
    declineInvite() {
      this.socket.emit("declineInvite", {
        inviterId: this.invitation.inviterId,
        inviteeId: this.currentUserId,
      });

      // Clear the invitation after declining
      this.invitation = null;
    },
    copyUrl() {
      navigator.clipboard.writeText(window.location.href)
          .then(() => {
            alert("URL copied to clipboard!");
          })
          .catch(err => {
            console.error("Failed to copy: ", err);
          });
    }
  },
};
</script>
